import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, Loading, AlertController } from 'ionic-angular';
import { AwsProvider } from '../../providers/aws/aws';

@IonicPage()
@Component({
	selector: 'page-add-bvi-leads',
	templateUrl: 'add-bvi-leads.html',
})
export class AddBviLeadsPage {
	userRecord: object;
	showSuccess: boolean;
	errorMessage: string;

	constructor(public navCtrl: NavController, public navParams: NavParams, public aws: AwsProvider, public loadingCtrl: LoadingController, public alertCtrl: AlertController) {
		this.userRecord = this.navParams.get('userRecord');
		console.log("userRecord:");
		console.log(JSON.stringify(this.userRecord));
		this.showSuccess = false;
	}

	/**
	 * Read & return the contents of the input file
	 */
	readFile() {
		return new Promise((resolve, reject) => {
			try { 
				let input: any = document.getElementById("upload-selection");
				let file = input.files[0];
				if (file) {
					const reader: FileReader = new FileReader();
					reader.readAsText(file);
					reader.onload = (e) => {
						const fileContent: string = reader.result as string;
						resolve(JSON.parse(fileContent));
					};
				 }else{
					resolve("no file");
				 }
			} catch (error) {
				reject(`Failure reading file: ${error}`);
			}
		});
	}

	/**
	 * Parse the file contents and return an array of lead rows.
	 * Find the object with type=table. The value of "data" in that object is 
	 * the array of lead rows that you need to send to the Lambda as leads.
	 */
	processFile() {
		let loading: Loading = this.loadingCtrl.create({});
		loading.present();
		this.readFile()
		.then((rawData) => {
			let rawLeads = [];
			// rawData should be an array of objects.
			if(Array.isArray(rawData)){
				for (let i=0; i<rawData.length; i++){
					if(rawData[i]["type"] === "table"){
						rawLeads = rawData[i]["data"];
						break;
					}
				}
				let params = { 
					user: this.userRecord,
					leads: rawLeads
				};
				/* Now pass the params to LambdaAdminGetBVIBackLeads. */
				return this.aws.invokeLambda('LambdaAdminGetBVIBackLeads', params)
				.then((response) => {
					loading.dismiss();
					//this.showSuccess = true;
					let msg = 'The leads have been added.';
					let alert = this.alertCtrl.create({
						message: msg,
						buttons: ['Ok'],
						enableBackdropDismiss: false
					});
					alert.present();
					return { success: true };
				}).catch((error) => {
					loading.dismiss();
					console.log('Failure adding leads.');
					let msg = JSON.stringify(error);
					let alert = this.alertCtrl.create({
						message: msg,
						buttons: ['Ok'],
						enableBackdropDismiss: false
					});
					alert.present();
				});

			}else{
				loading.dismiss();
				console.log("rawData has no length.");
				//this.showSuccess = false;
				//this.errorMessage = 'rawData has no length.';
				let msg = 'rawData has no length. There are no leads to add.';
				let alert = this.alertCtrl.create({
					message: msg,
					buttons: ['Ok'],
					enableBackdropDismiss: false
				});
				alert.present();
				return { success: false };
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/pages/add-bvi-leads/add-bvi-leads.ts